export const sourcePreviewSupportedFileExtensions = [
  "pdf",
  "jpeg",
  "jpg",
  "png",
  "webp",
  "svg",
  "gif",
  "json",
  "csv",
  "xls",
  "xlsx",
  "xlsm",
  "doc",
  "docx"
];
export const sourcePreviewSupportedFileTypes = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/svg+xml",
  "image/gif",
  "application/json",
  "text/csv",
  "application/csv",
  "application/vnd.msexcel",
  "application/vnd.ms-excel",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
